export default __webpack_public_path__ + "static/media/gift-landing-mobile.815b62e9.webp";